import { Col } from "./Flexbox";
import Text from "./Text";

const NavTab = props => {
    return (
        <Col 
        onClick={() => props.navigate(props.location)}
        style={{
            
            border:`solid 1px ${props.theme.Ey}`,
            borderRadius: 4,
            height: 43,
            paddingTop: 10,
            paddingRight: 20,
            paddingBottom: 10,
            paddingLeft: 20,
            alignItems: 'flex-start',
            flex:'none',
            position:'relative',
            cursor: 'pointer'
            }}>
            <Text color={props.active ? props.theme.Magenta : props.theme.Audi}>{props.text}</Text>
            {props.active && (<div style={{borderTop:`3px solid ${props.theme.Magenta}`, width: 19, transform: 'rotate(90deg)', position:'absolute', left:-10, borderRadius:4}}/>)}
        </Col>
    )
}

export default NavTab;